import {configureStore} from '@reduxjs/toolkit';
import rootReducers from './reducers/rootReducer';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas/rootSaga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

const sagaMiddleware =createSagaMiddleware();

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'],
  };

const persistedReducer = persistReducer(persistConfig, rootReducers);


const store = configureStore({
    reducer: persistedReducer,
    middleware: ()=>[sagaMiddleware]
});

sagaMiddleware.run(rootSaga);

let persistor = persistStore(store);

export { store, persistor };